/* eslint-disable react-refresh/only-export-components */
import { createContext, useContext, useEffect, useState } from 'react';
import { getEquipment } from './_requests';
import { Equipment } from './_models';
import { useAuth } from '../auth/AuthContext';

interface EquipmentContextProps {
  equipment: Equipment[];
}

const EquipmentContext = createContext<EquipmentContextProps | undefined>(
  undefined
);

export const useEquipmentContext = () => {
  const context = useContext(EquipmentContext);
  if (!context) {
    throw new Error(
      'useEquipmentContext must be used within a EquipmentProvider'
    );
  }
  return context;
};

export function EquipmentProvider({ children }: { children: React.ReactNode }) {
  const [equipment, setEquipment] = useState<Equipment[]>([]);
  const { currentUser } = useAuth();

  useEffect(() => {
    if (!currentUser) return;

    getEquipment().then(({ data }) => {
      setEquipment(data);
    });
  }, [currentUser]);

  return (
    <EquipmentContext.Provider value={{ equipment }}>
      {children}
    </EquipmentContext.Provider>
  );
}
